"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _color = _interopRequireDefault(require("color"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cccisdColorPicker = require("cccisd-color-picker");
var _FooterLink = _interopRequireDefault(require("./FooterLink"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var hostName = window.location.hostname;
var Appdefs = window.cccisd.appDefs;
var defaultValues = {
  backgroundColor: _style["default"].navbarDefaultBg,
  copyrightYear: new Date().getFullYear(),
  copyrightAttribution: '3C Institute',
  grantAttribution: '',
  showPolicyLinks: true,
  showContactUsLink: true,
  showTermsLink: true,
  showPolicyLink: true,
  contactUsLink: "https://www.3cisd.com/?r=".concat(hostName, "/#ccc-lets-talk"),
  termsLink: "https://www.3cisd.com/terms-of-use/?r=".concat(hostName),
  policyLink: "https://www.3cisd.com/privacy-policy/?r=".concat(hostName)
};
var propsThatShouldNotBeEmptyStrings = ['backgroundColor', 'copyrightYear', 'contactUsLink', 'termsLink', 'policyLink', 'copyrightAttribution'];
var Footer = function Footer(props) {
  var _Appdefs$app;
  var appdefsFooterObject = (Appdefs === null || Appdefs === void 0 ? void 0 : (_Appdefs$app = Appdefs.app) === null || _Appdefs$app === void 0 ? void 0 : _Appdefs$app.footer) || {};
  var propValues = Object.keys(defaultValues).reduce(function (allValues, variable) {
    if (variable in props) {
      allValues[variable] = props[variable];
    } else if (variable in appdefsFooterObject) {
      allValues[variable] = appdefsFooterObject[variable];
    } else {
      allValues[variable] = defaultValues[variable];
    }

    // this catches the case where the prop is passed in as an empty value, for a prop that needs a default if empty
    if (!allValues[variable] && propsThatShouldNotBeEmptyStrings.includes(variable)) {
      allValues[variable] = defaultValues[variable];
    }
    return allValues;
  }, {});
  var backgroundColor = propValues.backgroundColor,
    copyrightYear = propValues.copyrightYear,
    copyrightAttribution = propValues.copyrightAttribution,
    grantAttribution = propValues.grantAttribution,
    showPolicyLinks = propValues.showPolicyLinks,
    showContactUsLink = propValues.showContactUsLink,
    showTermsLink = propValues.showTermsLink,
    showPolicyLink = propValues.showPolicyLink,
    contactUsLink = propValues.contactUsLink,
    termsLink = propValues.termsLink,
    policyLink = propValues.policyLink;
  var bgColor = (0, _cccisdColorPicker.getColor)(backgroundColor);
  var bgLuminosity = (0, _color["default"])(bgColor).luminosity();

  /* Footer text should not be very eye-catching, so only
  make it as dark as it needs to be for accessibility */
  var fontColor;
  if (bgLuminosity < 0.35) {
    fontColor = '#fff';
  } else if (bgLuminosity < 0.8) {
    fontColor = '#333';
  } else {
    fontColor = '#777';
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].footer,
    style: {
      backgroundColor: bgColor,
      color: fontColor
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: props.className
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].wrapper
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("p", {
    style: grantAttribution ? {
      marginBottom: 4
    } : {
      marginBottom: 0
    }
  }, "Software developed by", ' ', /*#__PURE__*/_react["default"].createElement(_FooterLink["default"], {
    color: fontColor,
    href: "https://www.3cisd.com?r=".concat(hostName),
    text: "3C Institute"
  }), ". \xA9 ", copyrightYear, " ", copyrightAttribution, ", All Rights Reserved."), grantAttribution && /*#__PURE__*/_react["default"].createElement("small", null, grantAttribution)), showPolicyLinks && /*#__PURE__*/_react["default"].createElement("div", null, showContactUsLink && /*#__PURE__*/_react["default"].createElement(_FooterLink["default"], {
    color: fontColor,
    href: contactUsLink,
    text: "Contact Us"
  }), showTermsLink && /*#__PURE__*/_react["default"].createElement(_FooterLink["default"], {
    color: fontColor,
    href: termsLink,
    text: "Terms of Use"
  }), showPolicyLink && /*#__PURE__*/_react["default"].createElement(_FooterLink["default"], {
    color: fontColor,
    href: policyLink,
    text: "Privacy Policy"
  })))));
};
Footer.propTypes = {
  backgroundColor: _propTypes["default"].string,
  className: _propTypes["default"].string,
  showPolicyLinks: _propTypes["default"].bool,
  copyrightAttribution: _propTypes["default"].string,
  copyrightYear: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  grantAttribution: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),
  showContactUsLink: _propTypes["default"].bool,
  showTermsLink: _propTypes["default"].bool,
  showPolicyLink: _propTypes["default"].bool,
  contactUsLink: _propTypes["default"].string,
  termsLink: _propTypes["default"].string,
  policyLink: _propTypes["default"].string
};
Footer.defaultProps = {
  className: 'container'
};
var _default = exports["default"] = Footer;